<template>
  <base-dialog v-model="isVisible">
    <dialog-template>
      <div
        slot="title"
        v-text="$t('send.to.email')"
      />

      <labeled-input
        slot="content"
        v-model="form.email"
        :disabled="loading"
        :error="$v.form.email.$error"
        :placeholder="$t('enter.email')"
        label="Email"
        required
        @focus="$v.form.email.$reset"
        @blur="$v.form.email.$touch"
      />

      <simple-button
        slot="submit"
        variant="primary"
        :disabled="isInvalidForm || loading"
        @click="handleSubmit"
      >
        {{ $t('common.send') }}
      </simple-button>

      <simple-button
        slot="cancel"
        variant="transparent"
        @click="isVisible = false"
      >
        {{ $t('common.cancel') }}
      </simple-button>
    </dialog-template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex';

import {
  email as emailValidator,
  required as requiredValidator
} from 'vuelidate/lib/validators';

import BaseDialog from 'molecules/base/Dialog';
import LabeledInput from 'molecules/common/LabeledInput';
import SimpleButton from 'molecules/common/SimpleButton';
import DialogTemplate from 'templates/DialogTemplate';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'TransactionReceiptModal',
  components: {
    BaseDialog,
    LabeledInput,
    SimpleButton,
    DialogTemplate,
  },
  created() {
    EVENT_BUS.$on('EVENT_SEND_TRANSACTION_RECEIPT', (data) => {
      this.receipt = data;
      this.isVisible = true;
    });
  },
  beforeDestroy() {
    EVENT_BUS.$off('EVENT_SEND_TRANSACTION_RECEIPT');
  },
  data() {
    return {
      receipt: null,
      form: {
        email: '',
      },
      loading: false,
      isVisible: false,
    };
  },
  validations() {
    return {
      form: {
        email: {
          required: requiredValidator,
          email: emailValidator,
        },
      },
    };
  },
  computed: {
    isInvalidForm() {
      return this.$v.form.$invalid;
    },
  },
  methods: {
    async handleSubmit() {
      if (this.isInvalidForm) {
        this.$alert({
          type: 'warning',
          text: 'mistakes.in.form',
        });
        return;
      }

      this.loading = true;

      try {
        await this.sendReceipt({
          email: this.form.email,
          paymentId: this.receipt.transactionId,
        });

        this.form.email = '';

        this.$alert({
          type: 'golubok',
          text: 'receipt.sent.to.email',
        });
      } catch {
        this.$alert({
          type: 'warning',
          text: 'error.in.system.try.later',
        });
      } finally {
        this.$v.form.$reset();

        this.loading = false;
        this.isVisible = false;
      }
    },
    ...mapActions('project', ['sendReceipt']),
  },
};
</script>
